import { useQuery } from 'react-query';
import SurveyService from '~/api/services/survey';
import { onError } from '~/utils/helpers';

const getSurveys = (data?) => useQuery(
  'surveys-list',
  () => SurveyService.getSurveys(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const showSurveyData = (id) => useQuery(
  'surveys-show-data',
  () => SurveyService.getSurveyShowData(id),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getSurveysOptions = () => useQuery(
  'surveys-list-options',
  SurveyService.getSurveysData,
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getSurveysCount = (data) => useQuery(
  'surveys-list-count',
  () => SurveyService.getSurveysCount(data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getSurveysFarmers = (id, data) => useQuery(
  'surveys-farmer-list',
  () => SurveyService.farmersListSurvey(id, data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getSurveysStatChartData = (id, data) => useQuery(
  'surveys-question-statistics-data',
  () => SurveyService.getSurveyQuestionStatistics(id, data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getSurveysStatTableData = (id, data) => useQuery(
  'surveys-question-table-data',
  () => SurveyService.getSurveyTableStatistics(id, data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

const getSurveyFarmerTableData = (id, data) => useQuery(
  'surveys-farmer-group-table-data',
  () => SurveyService.getSurveyFarmerGroupsData(id, data),
  {
    cacheTime: 60000,
    enabled: true,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    onError,
    select: (data) => {
      return data.data
    }
  }
)

export const SurveyQuery = {
  getSurveys,
  getSurveysOptions,
  getSurveysCount,
  showSurveyData,
  getSurveysFarmers,
  getSurveysStatChartData,
  getSurveysStatTableData,
  getSurveyFarmerTableData
}
